import React from "react";
import GenericMandatoryInput from "../GenericMandatoryInput";
import { CommonInputProps } from "./models";

const CompanyNameInput = (props: CommonInputProps) => {
  return <GenericMandatoryInput
    {...props}
    title={RESX.Company.CompanyName}
    maxLength={serverReference.constants.company.maxNameLength}
  />;
};

export default CompanyNameInput;